import { reactive, ref } from 'vue';

export const useFormFieldHook = (initialValue) => {
  const state = ref(initialValue);
  const validation = ref({ error: false, message: '' });

  const setValidation = ({ error, message }) => {
    validation.value.error = error;
    validation.value.message = message;
  };

  const setState = (newState) => {
    state.value = newState;

    if (validation.value.error) {
      setValidation({ error: false, message: '' });
    }
  };

  return [state, setState, validation, setValidation];
};

const useFormHook = (formModel) => {
  const constructFormValues = () => Object.entries(formModel).reduce((acc, [key, initialValue]) => {
    const [state, setState, validation, setValidation] = useFormFieldHook(initialValue);

    acc[key] = reactive({ state, setState, validation, setValidation });

    return acc;
  }, {});

  const formValues = constructFormValues();

  const isFormInvalid = () => Object.values(formValues).some(({ validation }) => validation.error);

  const resetFormErrors = () => {
    Object.values(formValues).forEach(({ validation, setValidation }) => {
      if (validation.error) {
        setValidation({ error: false, message: '' });
      }
    });
  };

  return {
    formValues,
    isFormInvalid,
    resetFormErrors,
  };
};

export default useFormHook;
